module.exports = new __parcel__URL__("shop_machines_christmas_tree.97dc16ee.png").toString();